import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Checkbox } from '../../Checkbox';
import { SelectMenuContext } from '../context';
import GroupSelectionList from '../GroupSelectionList/GroupSelectionList';
import { SelectMenuTypes, SelectOptionTypes } from '../helper';
import SelectAll from '../SelectMenu/SelectMenuBody/SelectAll';
import styles from '@dtsl/css-select-menu/dist/index.module.css';
function MultiSelectionList(props) {
  let {
    options,
    onSelect,
    isControlButton,
    selectAllLabel,
    unSelectAllLabel
  } = props;
  const {
    selectedValues,
    setSelectedValues,
    selectMenuMultiSelectRef,
    placeHolder
  } = useContext(SelectMenuContext);
  const setValue = (selectedObj, event) => {
    const {
      label,
      key
    } = selectedObj;
    const hasValue = selectedValues.some(item => item.label === label && item.key === key);
    let filteredValues = [];
    if (hasValue) {
      filteredValues = selectedValues.filter(item => !(item.label === label && item.key === key));
    } else {
      filteredValues = [...selectedValues, selectedObj];
    }
    !isControlButton && setSelectedValues(filteredValues);
    fireChangeEvent(filteredValues, event);
  };
  const fireChangeEvent = (filteredValues, event) => {
    if (onSelect, event) {
      onSelect(filteredValues, event);
    }
  };
  const renderOption = (option, index) => {
    let {
      key = index,
      label,
      helpText,
      addtionalInfo = () => {},
      disabled
    } = option;
    const isChecked = selectedValues.some(selectedValue => {
      return selectedValue.label === label && selectedValue.key === key;
    });
    const optionClass = classNames({
      [styles['sib-selectmenu-multi-option']]: true,
      [styles['selected']]: isChecked,
      [styles[option.className]]: !!option.className,
      [styles['locked']]: disabled
    });
    const addInfo = addtionalInfo();
    return /*#__PURE__*/React.createElement("li", {
      key: `${key}_${label}_${index}`,
      className: optionClass,
      role: "option",
      "aria-selected": isChecked ? 'true' : 'false',
      onClick: !disabled ? event => setValue(option, event) : null,
      onKeyDown: event => {
        if (event.key === 'Enter' && !disabled) {
          setValue(option, event);
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      key: key,
      title: label,
      className: styles['sib-selectmenu-option__content'],
      disabled: disabled
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['sib-selectmenu-option__content-left']
    }, /*#__PURE__*/React.createElement(Checkbox, {
      ellipsis: true,
      disabled: disabled,
      label: label,
      checked: isChecked,
      identifier: `sibCheckbox_${key}`,
      labelContainerClassName: styles['sib-checkbox-label'],
      labelClassName: styles['sib-checkbox-title-alias'],
      className: styles['sib-checkbox-wrapper'],
      variant: "positive",
      onChange: event => {
        event.stopPropagation();
      },
      onClick: e => {
        e.stopPropagation();
      },
      onKeyDown: event => {
        if (event.which === 13 || event.which === 32) {
          event.stopPropagation();
          setValue({
            ...option,
            key
          }, event);
        }
      },
      onFocus: event => {
        event.target.closest('li').classList.add(styles['focused']);
      },
      onBlur: event => {
        event.target.closest('li').classList.remove(styles['focused']);
      }
    }), helpText && /*#__PURE__*/React.createElement("span", {
      className: `${styles['sib-selectmenu-option__helptext']} ${styles['sib-add-space']}`
    }, helpText)), addInfo && /*#__PURE__*/React.createElement("span", {
      className: styles['additional-info']
    }, addtionalInfo())));
  };
  let ops = options.map((option, index) => {
    const {
      type
    } = option || {};
    if (type === SelectOptionTypes.GROUP_LIST) {
      let _options = option.items.map((item, idx) => renderOption(item, idx, option.type));
      return /*#__PURE__*/React.createElement(GroupSelectionList, {
        key: option.name || index,
        title: option.title,
        defaultOpen: true
      }, _options);
    } else {
      return renderOption(option, index);
    }
  });
  return /*#__PURE__*/React.createElement("ul", {
    className: styles['sib-selectmenu-options'],
    role: "presentation",
    ref: selectMenuMultiSelectRef
  }, /*#__PURE__*/React.createElement(SelectAll, {
    placeHolder: placeHolder,
    options: options,
    onSelect: onSelect,
    selectAllLabel: selectAllLabel,
    unSelectAllLabel: unSelectAllLabel
  }), ops);
}
MultiSelectionList.defaultProps = {
  options: [],
  selectAllLabel: 'Select all options',
  unSelectAllLabel: 'Unselect all options',
  onSelect: () => {},
  isControlButton: false,
  selectMenuType: SelectMenuTypes.MULTI_SELECTION
};
MultiSelectionList.propTypes = {
  selectAllLabel: PropTypes.string,
  unSelectAllLabel: PropTypes.string,
  onSelect: PropTypes.func,
  isControlButton: PropTypes.bool,
  selectMenuType: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    label: PropTypes.string,
    value: PropTypes.any,
    addtionalInfo: PropTypes.func
  }))
};
export default MultiSelectionList;